//
//
//
//
//
//
//
//
//
//
//
//

import CyMobileHeader from '../mobile/CyMobileHeader'
import CyMobileFooter from '../mobile/CyMobileFooter'
export default {
  name: 'CyMobileLayout',
  components: {
    CyMobileHeader,
    CyMobileFooter
  },
  props: {
    logoText: {
      type: String,
      required: false
    },
    logoMiniText: {
      type: String,
      required: false
    },
    showFooter: {
      type: Boolean,
      default: true,
      required: false
    },
    showHeader: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data () {
    return {
      user: {}
    }
  },
  created () {}
}



// WEBPACK FOOTER //
// ./src/components/mobile/CyMobileLayout.vue